import AccountProfileForm from './AccountProfileForm';

export default AccountProfileForm;
